export function buildAccessPassSeatSelection({
  accessPassTemplate,
  quantity = 1,
}) {
  const qty = Math.max(1, Math.min(100, Number.parseInt(quantity, 10) || 1))
  const eventCount = Array.isArray(accessPassTemplate?.events)
    ? accessPassTemplate.events.length
    : 0
  const passName = accessPassTemplate?.name || 'Access Pass'
  const eventLabel = `${eventCount} event${eventCount === 1 ? '' : 's'}`

  const seats = {}
  const seatIds = {}
  for (let i = 1; i <= qty; i += 1) {
    const id = `access-pass-item-${i}`
    seatIds[id] = true
    seats[id] = {
      sectionNumber: passName,
      rowNumber: 'PASS',
      seatNumber: qty === 1 ? eventLabel : `#${i}`,
    }
  }

  return {
    quantity: qty,
    selectedSeatIds: { seats: seatIds },
    data: {
      seats,
      sections: {},
    },
  }
}

export function buildAccessPassAssignmentModalPayload({
  accessPassTemplate,
  organization,
  reloadAssignments,
  quantity = 1,
}) {
  const eventCount = Array.isArray(accessPassTemplate?.events)
    ? accessPassTemplate.events.length
    : 0
  const pricingTiers =
    accessPassTemplate?.pricingTiers?.length > 0
      ? accessPassTemplate.pricingTiers
      : [
          {
            id: `access-pass-${accessPassTemplate?.id}`,
            name: 'Access Pass',
            price: Number(accessPassTemplate?.price || 0),
          },
        ]
  // Prefer a paid assignment tier over template.price (null/0 when not sold online).
  const defaultTierPrice = Number(
    pricingTiers.find((tier) => Number(tier?.price) > 0)?.price ??
      pricingTiers[0]?.price ??
      accessPassTemplate?.price ??
      0
  )

  const seatSelection = buildAccessPassSeatSelection({
    accessPassTemplate,
    quantity,
  })

  const normalizedTemplate = {
    ...accessPassTemplate,
    accessPassMode: true,
    includeTax: false,
    additionalFees: 0,
    estimatedCombinedRate: 0,
    events: eventCount > 0 ? accessPassTemplate.events : [{ id: null }],
    pricingTiers,
    organizationUUID:
      accessPassTemplate?.organizationUUID || organization?.uuid,
    organization: accessPassTemplate?.organization || organization,
    currency:
      accessPassTemplate?.currency ||
      accessPassTemplate?.organization?.currency ||
      organization?.currency,
    price: Number.isFinite(defaultTierPrice) ? defaultTierPrice : 0,
  }

  const payload = {
    eventPackage: normalizedTemplate,
    selectedSeatIds: seatSelection.selectedSeatIds,
    data: seatSelection.data,
  }

  if (typeof reloadAssignments === 'function') {
    payload.reloadAssignments = reloadAssignments
  }

  return payload
}
